export default[
    {
        path: '/dataList/dailyBusiness',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '营业日报',
            authLogin: true
        }
    }
]